import React from "react";
import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import Login from "../main/Login";
import Index from "../main/Index";
import Dashboard from "../main/Dashboard";
import Batches from "../main/Batches";
import Tasks from "../main/Tasks";
import Users from "../main/Users";
import RoleBasedLayout from "../Layout/RoleBasedLayout";
import RoleProtectedRoute from "../components/RoleProtectedRoute";

const TasksLayout = () => (
  <RoleBasedLayout activeTab="tasks">
    <Outlet />
  </RoleBasedLayout>
);

const Routes = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "/dashboard",
      element: (
        <RoleBasedLayout activeTab="dashboard">
          <Dashboard />
        </RoleBasedLayout>
      ),
    },
    {
      path: "/batches",
      element: (
        <RoleProtectedRoute allowedRoles={["Admin"]}>
          <RoleBasedLayout activeTab="batches">
            <Batches />
          </RoleBasedLayout>
        </RoleProtectedRoute>
      ),
    },
    {
      path: "/tasks",
      element: <TasksLayout />,
      children: [
        {
          index: true, // This matches "/tasks" exactly
          element: <Tasks />,
        },
        {
          path: ":taskId/models", // This matches "/tasks/:taskId/models"
          element: <Index />,
        },
      ],
    },
    {
      path: "/users",
      element: (
        <RoleProtectedRoute allowedRoles={["Admin"]}>
          <RoleBasedLayout activeTab="users">
            <Users />
          </RoleBasedLayout>
        </RoleProtectedRoute>
      ),
    },
    {
      path: "/models",
      element: (
        <RoleProtectedRoute allowedRoles={["Admin"]}>
          <RoleBasedLayout activeTab="models">
            <Index />
          </RoleBasedLayout>
        </RoleProtectedRoute>
      ),
    },
  ]);

  return <RouterProvider router={router} />;
};

export default Routes;
